import React, { useCallback, useState, createContext, useContext } from 'react';
import { User } from '../types';
import { useScreenInit } from '../useScreenInit.js';
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<boolean>;
  register: (name: string, email: string, password: string) => Promise<boolean>;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
const mockUser: User = {
  id: '1',
  name: 'Ahmed Khan',
  email: 'ahmed@example.com',
  phone: '+92-300-1234567',
  addresses: [{
    id: '1',
    name: 'Ahmed Khan',
    phone: '+92-300-1234567',
    address: 'House 123, Street 45, Block B',
    city: 'Karachi',
    postalCode: '75500',
    isDefault: true
  }],
  createdAt: '2024-01-01'
};
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const screenInit = useScreenInit() as {
    loggedIn?: boolean;
  };
  const [user, setUser] = useState<User | null>(screenInit.loggedIn ? mockUser : null);
  const login = useCallback(async (email: string, password: string) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (email && password) {
      setUser(mockUser);
      return true;
    }
    return false;
  }, []);
  const register = useCallback(async (name: string, email: string, password: string) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (name && email && password) {
      setUser({
        ...mockUser,
        name,
        email
      });
      return true;
    }
    return false;
  }, []);
  const logout = useCallback(() => {
    setUser(null);
  }, []);
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    login,
    register,
    logout
  }} data-id="element-876" data-mp="1el08ffjmuw1o">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}